import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor;

import { observable, runInAction, makeObservable, computed } from "mobx";
import { persist } from "mobx-persist";
var PickupMethodModel = (_class = /*#__PURE__*/function () {
  function PickupMethodModel() {
    _classCallCheck(this, PickupMethodModel);

    _initializerDefineProperty(this, "_pickupMethod", _descriptor, this);

    makeObservable(this);
  }

  _createClass(PickupMethodModel, [{
    key: "pickupMethod",
    get: function get() {
      return this._pickupMethod;
    },
    set: function set(pickupMethod) {
      var _this = this;

      runInAction(function () {
        _this._pickupMethod = pickupMethod;
      });
    }
  }]);

  return PickupMethodModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_pickupMethod", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "pickupMethod", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pickupMethod"), _class.prototype)), _class);
export { PickupMethodModel as default };